import { Component, OnInit } from '@angular/core';
import { Card, CardManagementService } from '../card-management.service';

@Component({
  selector: 'app-learning-page',
  templateUrl: './learning-page.component.html',
  styleUrls: ['./learning-page.component.css']
})
export class LearningPageComponent implements OnInit {

  currentCard: Card;
  cards = [];
  flipped: boolean = false;

  constructor(private cardService: CardManagementService) { }

  ngOnInit() {
    this.cards = this.cardService.get();
    this.pickCard();
  }

  pickCard() {
    const index = Math.floor(Math.random() * this.cards.length);
    this.currentCard = this.cards[index];
  }

  flip() {
    if (this.flipped) {
      this.flipped = false;
      this.pickCard()
    } else {
      this.flipped = true;
    }
  }

}
